// Compact CSS-only donut chart for readiness scores.
// No charting library, just a conic-gradient ring + centred percentage.

export default function ReadinessDonut({ value = 0, size = 80, label, testid }) {
  const pct = Math.max(0, Math.min(100, Math.round(value)));
  const ring = pct >= 91 ? "#16A34A" : pct >= 71 ? "#2563EB"
              : pct >= 41 ? "#D97706" : "#DC2626";
  return (
    <div
      className="inline-flex items-center justify-center relative shrink-0"
      style={{ width: size, height: size }}
      data-testid={testid}
      role="img"
      aria-label={label || `Readiness ${pct}%`}>
      <div
        className="rounded-full"
        style={{
          width: size, height: size,
          background: `conic-gradient(${ring} ${pct * 3.6}deg, #E2E8F0 0)`,
        }} />
      <div
        className="absolute inset-1 rounded-full bg-white flex flex-col items-center justify-center">
        <span className="text-xl font-semibold tracking-tight text-[#0B1A36]">
          {pct}%
        </span>
      </div>
    </div>
  );
}
